module.exports = __webpack_public_path__ + "static/img/25-2.008283e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/25-2.jpg
// module id = +/+m
// module chunks = 0